module.exports = __webpack_public_path__ + "static/media/LY.16893c89.svg";